module.exports = __webpack_public_path__ + "static/4-003d5e43b12a89e6d616f42f340f67e6.jpg";